/**
 * Collar 数量选择器组件
 *
 * 功能：
 * - 管理产品数量的增减
 * - 验证输入合法性
 * - 同步到全局状态 Alpine.store('productState')
 *
 * 使用方式：
 * x-data="xQuantitySelector('section-id', 1)"
 */

if (!window.Eurus.loadedScript.includes('collar-quantity-selector.js')) {
  window.Eurus.loadedScript.push('collar-quantity-selector.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xQuantitySelector', (sectionId, initialQty = 1) => ({
        // 当前数量
        qty: initialQty,

        /**
         * 初始化函数
         * - 从 DOM input 同步初始值
         * - 监听数量变化，更新全局状态
         */
        init() {
          // 从 DOM 同步初始值
          const input = document.getElementById(`Quantity-${sectionId}`);
          if (input && input.value) {
            this.qty = parseInt(input.value) || 1;
          }

          // 监听数量变化，同步到全局状态
          this.$watch('qty', (newQty) => {
            if (Alpine.store('productState')) {
              Alpine.store('productState').quantity = newQty;
            }
          });
        },

        /**
         * 减少数量
         * @param {number} value - 减少的值，默认 1
         */
        minus(value = 1) {
          this.qty = parseInt(this.qty);
          this.qty = Math.max(1, this.qty - value); // 最小值为 1
        },

        /**
         * 增加数量
         * @param {number} value - 增加的值，默认 1
         */
        plus(value = 1) {
          this.qty = parseInt(this.qty);
          this.qty += value;
        },

        /**
         * 验证输入合法性
         * - 必须是整数
         * - 必须 >= 1
         * @param {HTMLElement} el - input 元素
         */
        invalid(el) {
          const number = parseFloat(el.value);
          if (!Number.isInteger(number) || number < 1) {
            this.qty = 1; // 重置为 1
          }
        }
      }));
    });
  });
}
